import { computed } from "vue"
import { useStore } from "vuex"

import {onMounted,onUpdated,onUnmounted} from 'vue'

import FilterComponent from '../FilterComponent/FilterComponent.vue'
import SiteNavigationMobile from './../SiteNavigation/SiteNavigationMobile.vue'

export default {
    name: "MobileMenuDrawer",
    components:{
        FilterComponent,
        SiteNavigationMobile
    },
    setup(){
        const store = useStore()
        const drawerContent = computed(()=>store.state.main.mobile_drawer_component)

        onMounted(()=>{
            window.addEventListener('resize',function closeMobileDrawerOnResize(){
                if(drawerContent) store.commit('main/set_mobile_drawer_component','')
            })
        })
        
        return {
            drawerContent
        }
    }
}